import { render, staticRenderFns } from "./shortGrid.vue?vue&type=template&id=5d889e6e&scoped=true&"
import script from "./shortGrid.vue?vue&type=script&lang=js&"
export * from "./shortGrid.vue?vue&type=script&lang=js&"
import style0 from "./shortGrid.vue?vue&type=style&index=0&id=5d889e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d889e6e",
  null
  
)

export default component.exports